import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuthStore } from './stores/authStore';
import Layout from './components/layout/Layout';
import LoginPage from './pages/LoginPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import DashboardPage from './pages/DashboardPage';
import AlertsPage from './pages/AlertsPage';
import SitesPage from './pages/SitesPage';
import CamerasPage from './pages/CamerasPage';
import CameraConfigPage from './pages/CameraConfigPage';
import CameraTrainingPage from './pages/CameraTrainingPage';
import DeletedCamerasPage from './pages/DeletedCamerasPage';
import ZonesPage from './pages/ZonesPage';
import IncidentsPage from './pages/IncidentsPage';
import ReportsPage from './pages/ReportsPage';
import SettingsPage from './pages/SettingsPage';
import NotificationsPage from './pages/NotificationsPage';
import AnalyticsPage from './pages/AnalyticsPage';
import UsersPage from './pages/UsersPage';
import UserCreatePage from './pages/UserCreatePage';
import AuditLogPage from './pages/AuditLogPage';
import RiskAnalyticsPage from './pages/RiskAnalyticsPage';
import WorkerAnalyticsPage from './pages/WorkerAnalyticsPage';
import WorkersPage from './pages/WorkersPage';
import ContractorAnalyticsPage from './pages/ContractorAnalyticsPage';
import ContractorsPage from './pages/ContractorsPage';
import BenchmarkingPage from './pages/BenchmarkingPage';
import NotFoundPage from './pages/NotFoundPage';
import ImpersonatePage from './pages/ImpersonatePage';

function ProtectedRoute({ children }) {
  const { isAuthenticated } = useAuthStore();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return children;
}

function RoleProtectedRoute({ children, roles }) {
  const { isAuthenticated, user } = useAuthStore();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (roles && !roles.includes(user?.role)) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
}

function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route path="/reset-password" element={<ResetPasswordPage />} />
      <Route path="/auth/impersonate" element={<ImpersonatePage />} />
      
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        <Route index element={<Navigate to="/dashboard" replace />} />
        <Route path="dashboard" element={<DashboardPage />} />
        <Route path="sites" element={<SitesPage />} />
        <Route path="alerts" element={<AlertsPage />} />
        <Route path="cameras" element={<CamerasPage />} />
        <Route path="cameras/deleted" element={<DeletedCamerasPage />} />
        <Route path="cameras/:id/config" element={<CameraConfigPage />} />
        <Route path="cameras/:id/training" element={<CameraTrainingPage />} />
        <Route path="zones" element={<ZonesPage />} />
        <Route path="incidents" element={<IncidentsPage />} />
        <Route path="analytics" element={<AnalyticsPage />} />
        <Route path="reports" element={<ReportsPage />} />
        <Route path="notifications" element={<NotificationsPage />} />
        <Route path="users" element={<RoleProtectedRoute roles={['org_admin', 'super_admin']}><UsersPage /></RoleProtectedRoute>} />
        <Route path="users/create" element={<RoleProtectedRoute roles={['org_admin', 'super_admin']}><UserCreatePage /></RoleProtectedRoute>} />
        <Route path="settings" element={<SettingsPage />} />
        <Route path="risk-analytics" element={<RiskAnalyticsPage />} />
        <Route path="workers" element={<WorkersPage />} />
        <Route path="worker-analytics" element={<WorkerAnalyticsPage />} />
        <Route path="contractors" element={<ContractorsPage />} />
        <Route path="contractor-analytics" element={<ContractorAnalyticsPage />} />
        <Route path="benchmarking" element={<BenchmarkingPage />} />
        <Route path="audit-log" element={<RoleProtectedRoute roles={['org_admin', 'super_admin']}><AuditLogPage /></RoleProtectedRoute>} />
      </Route>
      
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}

export default App;
